import { render, staticRenderFns } from "./UnitBulkCalendarRmStatistics.vue?vue&type=template&id=4444d9a8&scoped=true&"
import script from "./UnitBulkCalendarRmStatistics.vue?vue&type=script&lang=js&"
export * from "./UnitBulkCalendarRmStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4444d9a8",
  null
  
)

export default component.exports